<template>
  <div :class="['datatable-scroll', loadingTable]">
    <div
      class="tab-content"
      :class="['table-responsive mt-0 data-nowrap table-order']"
    >
      <div class="vuetable-wrapper ui basic segment">
        <vuetable
          :no-data-template="$t('No Data Available')"
          style="width: max-content;min-width: 100%;"
          class="dataTable thead-bg-fafafa"
          :api-mode="false"
          @vuetable:loading="showLoader"
          @vuetable:loaded="hideLoader"
          :data-manager="dataManager"
          ref="vuetable"
          data-path="data"
          :fields="table.field"
          pagination-path=""
          @vuetable:initialized="onInitialized"
          @vuetable:pagination-data="onPaginationData"
        >
          <template
            slot="channel"
            slot-scope="props"
          >
            <template v-if="props.rowData.channel == 'COD'">
              <a
                v-tooltip:top="$t('COD')"
                :data-original-title="$t('COD')"
              >
                <img
                  :src="$storeIndex.getImageSrc('payment/cod', '.svg')"
                  class="image_box mr-2"
                >
              </a>
            </template>
            <template v-else>
              <img
                v-if="props.rowData.logo"
                :src="props.rowData.logo"
                class="payment_image_box image_box mr-2"
              >
              <img
                v-else
                :src="$storeIndex.getImageSrc(`payment/${props.rowData.paymentId}`)"
                class="payment_image_box image_box mr-2"
              >
            </template>
            {{ $t(props.rowData.channel == "COD" ? '_Salepage.COD' : props.rowData.channel) }}
          </template>

          <template
            slot="growthRate"
            slot-scope="props"
          >
            <div
              v-if="props.rowData.growthRate == '-' || props.rowData.growthRate == 0"
              class="text-grey-300"
            >
              <span class="mr-1">0.00%</span>
            </div>
            <div
              v-else
              class="text-grey-300"
            >
              <span :class="[props.rowData.growthRate >= 0? 'text-green-custom': 'text-danger', 'mr-1']"><i :class="[props.rowData.growthRate >= 0? 'fa-arrow-up': 'fa-arrow-down', 'fas mr-1']" />{{ props.rowData.growthRate | formatNumber }}% </span> 
            </div>
          </template>
        </vuetable>
      </div>
    </div>
    <div class="datatable-footer">
      <vuetable-pagination-info
        class="dataTables_info ml-2"
        ref="paginationInfo"
        :no-data-template="$t('No relevant data')"
        :info-template="$t('Displaying {from} to {to} of {total} items')"
      />
      <vuetable-pagination
        class="dataTables_paginate paging_simple_numbers"
        ref="pagination"
        :css="table.cssPagination"
      />
    </div>
  </div>
</template>

<script>
import Vuetable from 'vuetable-2'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination.vue';
import VuetablePaginationInfo from '@/plugins/vuetable-2/VuetablePaginationInfo.vue';
// import VuetableRowHeader from 'vuetable-2/src/components/VuetableRowHeader.vue'
import Fields from './Fields'
import numeral from "numeral";
import Api from '@/services/endpoint/tenant.service'

export default {
    name: "TablePayment",
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        // VuetableRowHeader
    },
    // props:['pieChart'],
    props: {
        pieChart: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            loadingTable: '',
            table : {
                field: Fields
            },
            dataTable : [],
            sortOrder: [
                {
                    field: 'sales',
                    direction: 'asc'
                }
            ],
            paymentList:[]
        }
    },
    methods: {
        onInitialized(fields) {
            this.vuetableFields = fields;
        },
        showLoader() {
            this.loadingTable = "loading";
        },
        hideLoader() {
            this.loadingTable = "";
        },
        dataManager(sortOrder,pagination) {
            if(sortOrder.length) {
                const {direction,field} = sortOrder[0]
               
                if(direction === 'asc') {
                    this.dataTable = this.dataTable.sort((a, b) => a[field] - b[field]);
                }

                if(direction === 'desc') {
                    this.dataTable = this.dataTable.sort((a, b) => b[field] - a[field]);
                }

                this.showLoader()
                setTimeout(() => {
                    this.$refs.vuetable.setData(this.dataTable);
                    this.hideLoader()
                },1000)
                return
            }
            pagination = this.$refs.vuetable.makePagination(
                this.dataTable.length,25
            );
            return {
                pagination: pagination,
                data: this.dataTable
            }
            // 
        },
        onPaginationData(tablePagination) {
           
            tablePagination.pagination.total = this.dataTable.length
            tablePagination.pagination.to = this.dataTable.length
            this.$refs.paginationInfo.setPaginationData(tablePagination.pagination);
            this.$refs.pagination.setPaginationData(tablePagination);
            //this.onloadField(tablePagination);
        },
        async getPaymentMethodFn(){
          let data = await Api.PaymentMethod.getPaymentMethod()
          const result = data.data.data
          this.paymentList = result
        },
    },
    async mounted(){ 
        let data = this.pieChart.map(item => {
            return {
                "channel" : item.name,
                "orderQty" : item.value ,
                "productQty" : item.itemQty,
                "sales" : item.total,   
                "paymentId" : item.id,
                "growthRate" : item.growthRate,
                "logo" : item.logo
            }
        })
        this.dataTable = data ? data : [];
        this.$refs.vuetable.setData(this.dataTable);
    },
    filters: {
        formatNumber: function (value) {
            if (value == '-') {
                value = 0;
            }
            return numeral(value).format("0,0.0");
        },
    },
    created() {
    }
}
</script>

<style scoped>
    .datatable-scroll {
        border-radius: 3px 3px 0px 0px;
        border: 1px solid #DFDFDF;
    }
</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/table/TablePayment.vue